import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import NotFound from '@/views/NotFound'

import globals from '@/globals'

// Layouts
import Layout1 from '@/views/layout/Layout1'
import LayoutBlank from '@/views/layout/LayoutBlank'
import LayoutPublic from '@/views/layout/LayoutPublic'
import PermissionService from './services/permission.service'

Vue.use(Router)
Vue.use(Meta)

var permissions = []
PermissionService.getSystemPermission().then(res => {
  permissions = res.data.permissions
}).catch(err => console.log(err))

function getRoles (formName) {
  var form = permissions.find(i => i.formName === formName)
  if (form) {
    return form.roles
  }
  return null
}

function hasAcces (formName) {
  const roleName = localStorage.getItem('roleName')
  const roles = getRoles(formName)
  if (roles == null) return false
  var access = roles.includes(roleName)
  return access
}
function isAuthenticated () {
  var data = localStorage.getItem('isAuthenticated')
  if (data == null) return false
  else return data
}
function checkLoginRoute (to, from, next) {
  if (isAuthenticated()) { next('/welcome') } else { next() }
}
function guardAuthRoute (to, from, next) {
  var auth = to.meta.auth
  if (auth === true) {
    if (isAuthenticated()) {
      switch (to.name) {
        case 'admission':
          next(hasAcces('Admission'))
          break
        case 'studentlist':
          next(hasAcces('StudentList'))
          break
        case 'user':
          next(hasAcces('User'))
          break
        case 'role':
          next(hasAcces('Role'))
          break
        case 'permission':
          next(hasAcces('Permission'))
          break
        case 'specialpermission':
          next(hasAcces('SpecialPermission'))
          break
        case 'topic':
          next(hasAcces('Topic'))
          break
        case 'question':
          next(hasAcces('Question'))
          break
        case 'create':
          next(hasAcces('Exam'))
          break
        case 'assign':
          next(hasAcces('Assign'))
          break
        case 'myexam':
          next(hasAcces('MyExam'))
          break
        case 'take':
          next(hasAcces('Take'))
          break
        case 'result':
          next(hasAcces('Result'))
          break
        case 'class':
          next(hasAcces('Class'))
          break
        case 'section':
          next(hasAcces('Section'))
          break
        case 'subject':
          next(hasAcces('Subject'))
          break
        case 'gender':
          next(hasAcces('Gender'))
          break
        case 'general':
          next(hasAcces('General'))
          break
        case 'message':
          next(hasAcces('Message'))
          break
        default:
          next()
          break
      }
    } else {
      next('/login')
    }
  } else {
    next()
  }
}

const router = new Router({
  base: '/',
  mode: 'history',
  routes: [
    {
      path: '/',
      component: LayoutPublic,
      children: [
        {
          path: '',
          component: () => import('@/views/Home')
        },
        {
          path: 'application',
          component: () => import('@/views/Application')
        }
      ]
    },
    {
      path: '/student',
      component: Layout1,
      children: [
        {
          path: '/student/admission',
          component: () => import('@/views/student/Admission'),
          beforeEnter: guardAuthRoute,
          meta: { auth: true },
          name: 'admission'
        },
        {
          path: '/student/list',
          component: () => import('@/views/student/StudentList'),
          beforeEnter: guardAuthRoute,
          meta: { auth: true },
          name: 'studentlist'
        }
      ]
    },
    {
      path: '/welcome',
      component: Layout1,
      children: [
        {
          path: '',
          component: () => import('@/views/Welcome'),
          beforeEnter: guardAuthRoute,
          meta: { auth: true },
          name: 'welcome'
        }
      ]
    },
    {
      path: '/security',
      component: Layout1,
      children: [
        {
          path: '/security/user',
          component: () => import('@/views/security/User'),
          beforeEnter: guardAuthRoute,
          meta: { auth: true },
          name: 'user'
        },
        {
          path: '/security/role',
          component: () => import('@/views/security/Role'),
          beforeEnter: guardAuthRoute,
          meta: { auth: true },
          name: 'role'
        },
        {
          path: '/security/permission',
          component: () => import('@/views/security/Permission'),
          beforeEnter: guardAuthRoute,
          meta: { auth: true },
          name: 'permission'
        },
        {
          path: '/security/special-permission',
          component: () => import('@/views/security/SpecialPermission'),
          beforeEnter: guardAuthRoute,
          meta: { auth: true },
          name: 'specialpermission'
        }
      ]
    },
    {
      path: '/exam',
      component: Layout1,
      children: [
        {
          path: 'topic',
          component: () => import('@/views/exam/Topic'),
          beforeEnter: guardAuthRoute,
          meta: { auth: true },
          name: 'topic'
        },
        {
          path: 'question',
          component: () => import('@/views/exam/Question'),
          beforeEnter: guardAuthRoute,
          meta: { auth: true },
          name: 'question'
        },
        {
          path: 'exam',
          component: () => import('@/views/exam/Exam'),
          beforeEnter: guardAuthRoute,
          meta: { auth: true },
          name: 'exam'
        },
        {
          path: 'assign',
          component: () => import('@/views/exam/AssignExam'),
          beforeEnter: guardAuthRoute,
          meta: { auth: true },
          name: 'assign'
        },
        {
          path: 'myexam',
          component: () => import('@/views/exam/MyExam'),
          beforeEnter: guardAuthRoute,
          meta: { auth: true },
          name: 'myexam'
        },
        {
          path: 'take',
          component: () => import('@/views/exam/TakeExam'),
          beforeEnter: guardAuthRoute,
          meta: { auth: true },
          name: 'take'
        },
        {
          path: 'result',
          component: () => import('@/views/exam/ExamResult'),
          beforeEnter: guardAuthRoute,
          meta: { auth: true },
          name: 'result'
        }
      ]
    },
    {
      path: '/common',
      component: Layout1,
      children: [
        {
          path: 'class',
          component: () => import('@/views/common/Class'),
          beforeEnter: guardAuthRoute,
          meta: { auth: true }
        },
        {
          path: 'section',
          component: () => import('@/views/common/Section'),
          beforeEnter: guardAuthRoute,
          meta: { auth: true }
        },
        {
          path: 'subject',
          component: () => import('@/views/common/Subject'),
          beforeEnter: guardAuthRoute,
          meta: { auth: true }
        },
        {
          path: 'gender',
          component: () => import('@/views/common/Gender'),
          beforeEnter: guardAuthRoute,
          meta: { auth: true }
        }
      ]
    },
    {
      path: '/setting',
      component: Layout1,
      children: [
        {
          path: 'general',
          component: () => import('@/views/setting/General'),
          beforeEnter: guardAuthRoute,
          meta: { auth: true }
        },
        {
          path: 'message',
          component: () => import('@/views/setting/Message'),
          beforeEnter: guardAuthRoute,
          meta: { auth: true }
        }
      ]
    },
    {
      path: '/login',
      component: LayoutBlank,
      children: [
        { path: '',
          component: () => import('@/views/user/Login'),
          beforeEnter: checkLoginRoute
        }
      ]
    },
    {
      path: '*',
      component: NotFound
    }
  ]
})

router.afterEach(() => {
  const splashScreen = document.querySelector('.app-splash-screen')
  if (splashScreen) {
    splashScreen.style.opacity = 0
    setTimeout(
      () => splashScreen && splashScreen.parentNode.removeChild(splashScreen),
      300
    )
  }

  if (
    window.layoutHelpers &&
    window.layoutHelpers.isSmallScreen() &&
    !window.layoutHelpers.isCollapsed()
  ) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
  document.body.classList.add('app-loading')
  if (isAuthenticated()) {
    setTimeout(() => next(), 10)
  } else {
    next()
  }
})

export default router
